var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9375 8.30884V16.5313C1.9375 17.2938 2.2404 18.0251 2.77957 18.5643C3.31874 19.1034 4.05 19.4063 4.8125 19.4063H19.1875C19.95 19.4063 20.6813 19.1034 21.2204 18.5643C21.7596 18.0251 22.0625 17.2938 22.0625 16.5313V8.30884L13.5065 13.573C13.0534 13.8517 12.5319 13.9993 12 13.9993C11.4681 13.9993 10.9466 13.8517 10.4935 13.573L1.9375 8.30884Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0625 6.62017V6.46875C22.0625 5.70625 21.7596 4.97499 21.2204 4.43582C20.6813 3.89665 19.95 3.59375 19.1875 3.59375H4.8125C4.05 3.59375 3.31874 3.89665 2.77957 4.43582C2.2404 4.97499 1.9375 5.70625 1.9375 6.46875V6.62017L11.2467 12.3491C11.4733 12.4885 11.734 12.5622 12 12.5622C12.266 12.5622 12.5267 12.4885 12.7533 12.3491L22.0625 6.62017Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeMail);
export default __webpack_public_path__ + "static/media/officeMail.79f6ff807b41b8ca3ff78ebeeeb5be44.svg";
export { ForwardRef as ReactComponent };